import { render } from "./AllNewsView.vue?vue&type=template&id=4692cdb5"
import script from "./AllNewsView.vue?vue&type=script&lang=js"
export * from "./AllNewsView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__